import uploadsApiClient, {
  UploadFileInput,
  UploadResponse,
} from "../../../api/uploads";
import { UseKlydoMutationOptions } from "../../../components/hooks";
import useUploadMutation from "./useUploadMutation";

const useUploadCollectionSplashBackgroundMutation = (
  options: Omit<
    UseKlydoMutationOptions<
      UploadResponse,
      UploadFileInput,
      { previousUploadStatus: UploadResponse | undefined }
    >,
    "onSuccess" | "onSettled"
  > & {
    onSuccess?: (response: UploadResponse) => void;
    onSettled?: (response: UploadResponse | undefined, error: unknown) => void;
  } = {},
) => {
  return useUploadMutation(
    uploadsApiClient.uploadCollectionSplashBackground,
    "upload-collection-splash-background",
    options,
  );
};

export default useUploadCollectionSplashBackgroundMutation;
